module.exports = __webpack_public_path__ + "img/hexin-2.1f8a4c4d.jpg";